import React from 'react';
import useMobileLayout from 'Hooks/useMobileLayout';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import Desktop from './Desktop';
import Mobile from './Mobile';

export default function FilesPicker(props) {
  useScrollTopOnMount();
  const isMobile = useMobileLayout();

  const Component = isMobile ? Mobile : Desktop;

  return <Component {...props} />;
}
